import { render, staticRenderFns } from "./RiotsTable.vue?vue&type=template&id=5ccfe6dc&"
import script from "./RiotsTable.vue?vue&type=script&lang=js&"
export * from "./RiotsTable.vue?vue&type=script&lang=js&"
import style0 from "./RiotsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports